function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { useAction } from 'hooks';
import BackButton from 'components/BackButton';
import Modal from 'components/Modal';
import App, { AlertsBus } from 'modules/App';
import CloudDrive from 'modules/CloudDrive';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
const Back = ({ componentName, onSetComponent })=>{
    const isAddPatientComponent = componentName === 'AddPatient';
    const isChoosePatientComponent = componentName === 'ChoosePatient';
    if (!(isChoosePatientComponent || isAddPatientComponent)) {
        return null;
    }
    let newComponentName;
    if (isChoosePatientComponent) {
        newComponentName = 'DownloadSummary';
    } else if (isAddPatientComponent) {
        newComponentName = 'ChoosePatient';
    }
    const onClick = (evt)=>{
        evt.preventDefault();
        onSetComponent(newComponentName);
    };
    return /*#__PURE__*/ _jsx(BackButton, {
        to: "",
        onClick: onClick
    });
};
const DownloadDataModal = ({ connectorType, components, defaultComponentName })=>{
    const connectionId = useSelector(selectors.connectionId);
    const connectionStatus = useSelector(selectors.connectionStatus);
    const downloader = useSelector(selectors.downloader);
    const driverInstallationState = get(downloader, 'driver.installationState');
    const openModalId = useSelector(App.selectors.modal);
    const isDisabled = useSelector(CloudDrive.selectors.isStoreReadingsInProgress);
    const defaultHeaderMessage = messages.headers.downloadDataFromMeter;
    const [componentName, setComponentName] = useState(defaultComponentName);
    const [headerMessage, setHeaderMessage] = useState(defaultHeaderMessage);
    const [styleModifier, setStyleModifier] = useState(null);
    const [selectedChannel, setSelectedChannel] = useState(null);
    const Component = get(components, componentName, null);
    const closeModal = useAction(App.actions.closeModal);
    const stopCheckingConnection = useAction(actions.stopCheckingConnection, connectionId, connectionStatus, true);
    const stopListeningBluetooth = useAction(actions.stopListeningBluetooth);
    const stopInstallBlueCableDriver = useAction(actions.stopInstallBlueCableDriver);
    const onClose = ()=>{
        closeModal();
        stopCheckingConnection();
        if (selectedChannel === 'Bluetooth') stopListeningBluetooth();
        if (driverInstallationState === 'Started' || driverInstallationState === 'InProgress') stopInstallBlueCableDriver();
        setComponentName(defaultComponentName);
        setHeaderMessage(defaultHeaderMessage);
    };
    const onSetHeaderMessage = (newHeaderMessage = defaultHeaderMessage)=>{
        setHeaderMessage(newHeaderMessage);
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        modalId: constants.DOWNLOAD_DATA_MODAL,
        openModalId: openModalId,
        styleModifier: styleModifier,
        isDisabled: isDisabled,
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx(Back, {
                componentName: componentName,
                onSetComponent: setComponentName
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "modal__header",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, headerMessage))
            }),
            /*#__PURE__*/ _jsx(AlertsBus, {
                className: "mb-4"
            }),
            /*#__PURE__*/ _jsx(Component, {
                connectorType: connectorType,
                selectedChannel: selectedChannel,
                onSetComponent: setComponentName,
                onSetHeaderMessage: onSetHeaderMessage,
                onSetStyleModifier: setStyleModifier,
                onSetChannel: setSelectedChannel,
                onCancel: onClose
            })
        ]
    });
};
export default DownloadDataModal;
